import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { DxDataGridModule } from 'devextreme-angular';
import { Contract } from 'src/app/pages/contracts/contract-form/contract-form.component';
import { StatusPillComponent } from 'src/app/components/status-pill/status-pill.component';
import { ContractStatusConfig } from 'src/app/constants/status-pill-configs';

@Component({
    selector: 'app-project-connection-step',
    imports: [CommonModule, DxDataGridModule, StatusPillComponent],
    templateUrl: './project-connection-step.component.html',
    styleUrl: './project-connection-step.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectConnectionStepComponent {
  readonly contractStatusConfig = ContractStatusConfig;

  @ViewChild('contractSelectorDatagrid') contractSelectorDatagrid: any;

  @Input() siteContracts: Contract[] = [];
  @Input() contractTypes: any[] = [];
  @Input() selectedContractIds: number[] = [];

  @Output() selectedContractIdsChange = new EventEmitter<number[]>();

  headerText = $localize`:@@linkContractProjectHeader:Contracts are already assigned to the selected location. Would you also like to link these existing contracts to the new project?`;
  subHeaderText = $localize`:@@linkContractProjectSub:Select the contracts you would like to link to the new project.`;

  onSelectionChanged(e: any) {
    this.selectedContractIdsChange.emit(e.selectedRowKeys as number[]);
  }

  onCellPrepared(e: any) {
    if ((e.columnIndex == 5 && e.rowType == 'header') || (e.columnIndex == 1 && e.rowType == 'header')) {
      // The indicator span is not always at this position - a column without a header
      // filter has only the sort span, so childNodes[1] is undefined and this threw once
      // per header cell. Guarded rather than re-targeted: childNodes[1] resolves to the
      // sort span on some columns and the header filter on others, so the original
      // intent is ambiguous and worth a deliberate decision.
      const target = e.cellElement?.childNodes?.[0]?.childNodes?.[1] as HTMLElement | undefined;
      target?.style?.setProperty('display', 'none');
    }
  }
}
